'use strict';

module.exports = function () {
    $('.producttiles-carousel').slick({
        slidesToShow: 4,
        slidesToscroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
};

